import type { QueryClient } from "@tanstack/react-query";

export const invalidateVersionHistoryQueries = (
  queryClient: QueryClient,
  wid: number,
  tableId: string,
  sheetId: string,
) =>
  queryClient.invalidateQueries({
    queryKey: ["smart-tables", wid, tableId, sheetId, "versions"],
  });
